import { useState } from 'react';
import { commentWall } from '@/mocks/home';

export default function CommentWall() {
  const [liked, setLiked] = useState<string[]>([]);
  const [draft, setDraft] = useState('');
  const [notice, setNotice] = useState('');

  const toggleLike = (id: string) => {
    setLiked((prev) => (prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]));
  };

  const handlePublish = () => {
    if (!draft.trim()) {
      setNotice('先写点什么，再发到热评墙。');
      return;
    }
    setNotice('已记录你的草稿。演示页面暂不接发表接口，登录后即可公开发言。');
  };

  return (
    <section id="comments" className="scroll-mt-28 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-shell px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[0.72fr_1.28fr] lg:gap-12">
          <div className="lg:sticky lg:top-32 lg:self-start">
            <span className="font-label text-xs tracking-[0.24em] text-primary-600">
              COMMENTS / 热评现场
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
              翻旧账最热闹的地方，在评论区
            </h2>
            <p className="mt-4 font-body text-sm leading-8 text-foreground-600">
              很多人是先看热评、再回头补往期。这里的留言都挂在对应的存档条目下面，谁当年怎么说的、
              如今又怎么看，对照着读最有意思。
            </p>

            <div className="mt-7 grid grid-cols-2 gap-3">
              <div className="rounded-lg border border-background-200 bg-background-50 p-4">
                <p className="font-heading text-2xl font-black text-primary-600">18.4 万</p>
                <p className="mt-1 font-label text-xs text-foreground-500">累计评论</p>
              </div>
              <div className="rounded-lg border border-background-200 bg-background-50 p-4">
                <p className="font-heading text-2xl font-black text-accent-700">6.2 万</p>
                <p className="mt-1 font-label text-xs text-foreground-500">本周新增考古</p>
              </div>
            </div>

            <div className="mt-6">
              <label htmlFor="comment-draft" className="font-label text-xs text-foreground-500">
                我也说两句
              </label>
              <textarea
                id="comment-draft"
                rows={3}
                maxLength={500}
                value={draft}
                onChange={(event) => {
                  setDraft(event.target.value);
                  setNotice('');
                }}
                placeholder="说说你翻到的那条旧料……"
                className="mt-2 w-full resize-none rounded-md border border-background-300 bg-background-50 px-3 py-2.5 font-body text-sm leading-6 text-foreground-900 placeholder:text-foreground-500 focus:border-primary-400 focus:outline-none"
              ></textarea>
              <div className="mt-2 flex items-center justify-between gap-3">
                <span className="font-label text-[11px] text-foreground-500">{draft.length}/500</span>
                <button
                  type="button"
                  onClick={handlePublish}
                  className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 font-label text-sm text-background-50 transition-colors hover:bg-primary-600"
                >
                  发到热评墙
                </button>
              </div>
              {notice && (
                <p className="anim-fade-in mt-3 rounded-md border border-accent-300 bg-accent-50 px-3 py-2 font-body text-xs leading-6 text-accent-900">
                  {notice}
                </p>
              )}
            </div>
          </div>

          <div className="flex flex-col gap-4">
            {commentWall.map((item) => {
              const isLiked = liked.includes(item.id);
              return (
                <article
                  key={item.id}
                  className="rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200"
                >
                  <div className="flex items-start gap-3">
                    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-foreground-950 font-heading text-base font-bold text-background-50">
                      {item.initial}
                    </span>
                    <div className="min-w-0 flex-1">
                      <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                        <span className="font-heading text-sm font-bold text-foreground-950">
                          {item.user}
                        </span>
                        <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 font-label text-[11px] text-secondary-900">
                          {item.badge}
                        </span>
                        <span className="font-label text-[11px] text-foreground-500">{item.time}</span>
                      </div>
                      <p className="mt-2.5 font-body text-sm leading-7 text-foreground-700">
                        {item.content}
                      </p>
                      <div className="mt-3 flex items-center gap-5">
                        <button
                          type="button"
                          onClick={() => toggleLike(item.id)}
                          className={`flex cursor-pointer items-center gap-1.5 font-label text-xs transition-colors ${
                            isLiked ? 'text-primary-600' : 'text-foreground-500 hover:text-primary-600'
                          }`}
                        >
                          <i className={isLiked ? 'ri-heart-3-fill text-sm' : 'ri-heart-3-line text-sm'}></i>
                          {isLiked ? item.likes + 1 : item.likes}
                        </button>
                        <button
                          type="button"
                          className="flex cursor-pointer items-center gap-1.5 font-label text-xs text-foreground-500 transition-colors hover:text-secondary-800"
                        >
                          <i className="ri-chat-3-line text-sm"></i>
                          {item.replies} 条回复
                        </button>
                        <button
                          type="button"
                          className="flex cursor-pointer items-center gap-1.5 font-label text-xs text-foreground-500 transition-colors hover:text-secondary-800"
                        >
                          <i className="ri-share-forward-line text-sm"></i>
                          分享这条旧料
                        </button>
                      </div>
                    </div>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}